import { render, staticRenderFns } from "./InsertSchulbildung.vue?vue&type=template&id=b7ef4026"
import script from "./InsertSchulbildung.vue?vue&type=script&lang=js"
export * from "./InsertSchulbildung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports